import { TaxCodes } from "@/shared/enums/taxCodes.enum";
import { TaxType } from "@/shared/enums/taxes.enum";
import i18n from "@/app/plugins/i18n";

export const taxCodesDetails = {
  [TaxCodes.ACCOUNT_DEFAULT]: {
    type: TaxType.DEFAULT,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ACCOUNT_DEFAULT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ACCOUNT_DEFAULT}.name`),
  },
  [TaxCodes.GENERAL_TANGIBLE_GOODS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GENERAL_TANGIBLE_GOODS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GENERAL_TANGIBLE_GOODS}.name`),
  },
  [TaxCodes.GENERAL_SERVICES]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GENERAL_SERVICES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GENERAL_SERVICES}.name`),
  },
  [TaxCodes.GENERAL_ELECTRONIC_SERVICES]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GENERAL_ELECTRONIC_SERVICES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GENERAL_ELECTRONIC_SERVICES}.name`),
  },
  [TaxCodes.NONTAXABLE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NONTAXABLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NONTAXABLE}.name`),
  },
  [TaxCodes.IAAS_PERSONAL]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.IAAS_PERSONAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.IAAS_PERSONAL}.name`),
  },
  [TaxCodes.IAAS_BUSINESS]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.IAAS_BUSINESS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.IAAS_BUSINESS}.name`),
  },
  [TaxCodes.PAAS_BUSINESS]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PAAS_BUSINESS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PAAS_BUSINESS}.name`),
  },
  [TaxCodes.PAAS_PERSONAL]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PAAS_PERSONAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PAAS_PERSONAL}.name`),
  },
  [TaxCodes.SAAS_PERSONAL]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SAAS_PERSONAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SAAS_PERSONAL}.name`),
  },
  [TaxCodes.SAAS_BUSINESS]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SAAS_BUSINESS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SAAS_BUSINESS}.name`),
  },
  [TaxCodes.SAAS_DOWNLOAD_PERSONAL]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SAAS_DOWNLOAD_PERSONAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SAAS_DOWNLOAD_PERSONAL}.name`),
  },
  [TaxCodes.SAAS_DOWNLOAD_BUSINESS]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SAAS_DOWNLOAD_BUSINESS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SAAS_DOWNLOAD_BUSINESS}.name`),
  },
  [TaxCodes.CLOUD_BUSINESS]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CLOUD_BUSINESS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CLOUD_BUSINESS}.name`),
  },
  [TaxCodes.GAMES_DOWNLOAD_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GAMES_DOWNLOAD_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GAMES_DOWNLOAD_PERMANENT}.name`),
  },
  [TaxCodes.GAMES_DOWNLOAD_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GAMES_DOWNLOAD_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GAMES_DOWNLOAD_LIMITED}.name`),
  },
  [TaxCodes.GAMES_DOWNLOAD_SUBSCRIPTION]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GAMES_DOWNLOAD_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GAMES_DOWNLOAD_SUBSCRIPTION}.name`),
  },
  [TaxCodes.GAMES_STREAM_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GAMES_STREAM_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GAMES_STREAM_LIMITED}.name`),
  },
  [TaxCodes.GAMES_STREAM_SUBSCRIPTION]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GAMES_STREAM_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GAMES_STREAM_SUBSCRIPTION}.name`),
  },
  [TaxCodes.SOFTWARE_DOWNLOAD_PERSONAL]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_DOWNLOAD_PERSONAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_DOWNLOAD_PERSONAL}.name`),
  },
  [TaxCodes.SOFTWARE_DOWNLOAD_NONREC]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_DOWNLOAD_NONREC}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_DOWNLOAD_NONREC}.name`),
  },
  [TaxCodes.SOFTWARE_DOWNLOAD_BUSINESS]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_DOWNLOAD_BUSINESS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_DOWNLOAD_BUSINESS}.name`),
  },
  [TaxCodes.SOFTWARE_CUSTOM_PERSONAL]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_CUSTOM_PERSONAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_CUSTOM_PERSONAL}.name`),
  },
  [TaxCodes.SOFTWARE_CUSTOM_BUSINESS]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_CUSTOM_BUSINESS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_CUSTOM_BUSINESS}.name`),
  },
  [TaxCodes.AUDIOBOOK]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AUDIOBOOK}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIOBOOK}.name`),
  },
  [TaxCodes.BOOKS_DOWNLOAD_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BOOKS_DOWNLOAD_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BOOKS_DOWNLOAD_PERMANENT}.name`),
  },
  [TaxCodes.BOOKS_DOWNLOAD_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BOOKS_DOWNLOAD_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BOOKS_DOWNLOAD_LIMITED}.name`),
  },
  [TaxCodes.BOOKS_DOWNLOAD_SUBSCRIPTION]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BOOKS_DOWNLOAD_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BOOKS_DOWNLOAD_SUBSCRIPTION}.name`),
  },
  [TaxCodes.BOOKS_VIEW_SUBSCRIPTION]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BOOKS_VIEW_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BOOKS_VIEW_SUBSCRIPTION}.name`),
  },
  [TaxCodes.MAGAZINES_DOWNLOAD_SUBSCRIPTION]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_DOWNLOAD_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_DOWNLOAD_SUBSCRIPTION}.name`),
  },
  [TaxCodes.MAGAZINES_TANGIBLE_DIGITAL]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_TANGIBLE_DIGITAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_TANGIBLE_DIGITAL}.name`),
  },
  [TaxCodes.MAGAZINES_VIEW_SUBSCRIPTION]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_VIEW_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_VIEW_SUBSCRIPTION}.name`),
  },
  [TaxCodes.MAGAZINES_DOWNLOAD_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_DOWNLOAD_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_DOWNLOAD_PERMANENT}.name`),
  },
  [TaxCodes.MAGAZINES_VIEW_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_VIEW_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_VIEW_LIMITED}.name`),
  },
  [TaxCodes.MAGAZINES_VIEW_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_VIEW_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_VIEW_PERMANENT}.name`),
  },
  [TaxCodes.MAGAZINES_DOWNLOAD_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_DOWNLOAD_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MAGAZINES_DOWNLOAD_LIMITED}.name`),
  },
  [TaxCodes.NEWSPAPERS_DOWNLOAD_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_DOWNLOAD_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_DOWNLOAD_PERMANENT}.name`),
  },
  [TaxCodes.NEWSPAPERS_VIEW_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_VIEW_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_VIEW_LIMITED}.name`),
  },
  [TaxCodes.NEWSPAPERS_VIEW_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_VIEW_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_VIEW_PERMANENT}.name`),
  },
  [TaxCodes.NEWSPAPERS_DOWNLOAD_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_DOWNLOAD_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_DOWNLOAD_LIMITED}.name`),
  },
  [TaxCodes.NEWSPAPERS_DOWNLOAD_SUBSCRIPTION]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_DOWNLOAD_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_DOWNLOAD_SUBSCRIPTION}.name`),
  },
  [TaxCodes.NEWSPAPERS_TANGIBLE_DIGITAL]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_TANGIBLE_DIGITAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_TANGIBLE_DIGITAL}.name`),
  },
  [TaxCodes.NEWSPAPERS_VIEW_SUBSCRIPTION]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_VIEW_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS_VIEW_SUBSCRIPTION}.name`),
  },
  [TaxCodes.TEXTBOOKS_DOWNLOAD_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TEXTBOOKS_DOWNLOAD_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TEXTBOOKS_DOWNLOAD_LIMITED}.name`),
  },
  [TaxCodes.TEXTBOOKS_DOWNLOAD_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TEXTBOOKS_DOWNLOAD_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TEXTBOOKS_DOWNLOAD_PERMANENT}.name`),
  },
  [TaxCodes.AUDIO_STREAM_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AUDIO_STREAM_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIO_STREAM_LIMITED}.name`),
  },
  [TaxCodes.AUDIO_DOWNLOAD_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AUDIO_DOWNLOAD_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIO_DOWNLOAD_LIMITED}.name`),
  },
  [TaxCodes.AUDIO_DOWNLOAD_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AUDIO_DOWNLOAD_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIO_DOWNLOAD_PERMANENT}.name`),
  },
  [TaxCodes.AUDIO_STREAM_SUBSCRIPTION]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AUDIO_STREAM_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIO_STREAM_SUBSCRIPTION}.name`),
  },
  [TaxCodes.AUDIOVISUAL_STREAM_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AUDIOVISUAL_STREAM_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIOVISUAL_STREAM_LIMITED}.name`),
  },
  [TaxCodes.AUDIOVISUAL_DOWNLOAD_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AUDIOVISUAL_DOWNLOAD_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIOVISUAL_DOWNLOAD_PERMANENT}.name`),
  },
  [TaxCodes.AUDIOVISUAL_DOWNLOAD_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AUDIOVISUAL_DOWNLOAD_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIOVISUAL_DOWNLOAD_LIMITED}.name`),
  },
  [TaxCodes.AUDIOVISUAL_STREAM_SUBSCRIPTION]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AUDIOVISUAL_STREAM_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIOVISUAL_STREAM_SUBSCRIPTION}.name`),
  },
  [TaxCodes.VIDEO_STREAM_LIVE]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.VIDEO_STREAM_LIVE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.VIDEO_STREAM_LIVE}.name`),
  },
  [TaxCodes.PHOTOS_DOWNLOAD_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PHOTOS_DOWNLOAD_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PHOTOS_DOWNLOAD_PERMANENT}.name`),
  },
  [TaxCodes.GIFT_CARD]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GIFT_CARD}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GIFT_CARD}.name`),
  },
  [TaxCodes.NEWS_DOWNLOAD_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWS_DOWNLOAD_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWS_DOWNLOAD_PERMANENT}.name`),
  },
  [TaxCodes.NEWS_DOWNLOAD_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWS_DOWNLOAD_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWS_DOWNLOAD_LIMITED}.name`),
  },
  [TaxCodes.NEWS_DOWNLOAD_SUBSCRIPTION]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWS_DOWNLOAD_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWS_DOWNLOAD_SUBSCRIPTION}.name`),
  },
  [TaxCodes.NEWS_VIEW_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWS_VIEW_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWS_VIEW_LIMITED}.name`),
  },
  [TaxCodes.NEWS_VIEW_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWS_VIEW_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWS_VIEW_PERMANENT}.name`),
  },
  [TaxCodes.NEWS_VIEW_SUBSCRIPTION]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWS_VIEW_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWS_VIEW_SUBSCRIPTION}.name`),
  },
  [TaxCodes.SOFTWARE_DOCS_CUSTOM]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_DOCS_CUSTOM}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_DOCS_CUSTOM}.name`),
  },
  [TaxCodes.SOFTWARE_DOCS_PREWRITTEN]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_DOCS_PREWRITTEN}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SOFTWARE_DOCS_PREWRITTEN}.name`),
  },
  [TaxCodes.ARTWORK_DOWNLOAD_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ARTWORK_DOWNLOAD_LIMITED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ARTWORK_DOWNLOAD_LIMITED}.name`),
  },
  [TaxCodes.ARTWORK_DOWNLOAD_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ARTWORK_DOWNLOAD_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ARTWORK_DOWNLOAD_PERMANENT}.name`),
  },
  [TaxCodes.ARTWORK_DOWNLOAD_SUBSCRIPTION]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ARTWORK_DOWNLOAD_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ARTWORK_DOWNLOAD_SUBSCRIPTION}.name`),
  },
  [TaxCodes.GREETING_CARDS_AUDIO]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GREETING_CARDS_AUDIO}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GREETING_CARDS_AUDIO}.name`),
  },
  [TaxCodes.GREETING_CARDS_AUDIOVISUAL]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GREETING_CARDS_AUDIOVISUAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GREETING_CARDS_AUDIOVISUAL}.name`),
  },
  [TaxCodes.GREETING_CARDS_STATIC]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GREETING_CARDS_STATIC}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GREETING_CARDS_STATIC}.name`),
  },
  [TaxCodes.WEBSITE_ADVERTISING]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WEBSITE_ADVERTISING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WEBSITE_ADVERTISING}.name`),
  },
  [TaxCodes.WEBSITE_HOSTING]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WEBSITE_HOSTING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WEBSITE_HOSTING}.name`),
  },
  [TaxCodes.WEBSITE_DESIGN]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WEBSITE_DESIGN}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WEBSITE_DESIGN}.name`),
  },
  [TaxCodes.WEBSITE_DATA_PROCESSING]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WEBSITE_DATA_PROCESSING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WEBSITE_DATA_PROCESSING}.name`),
  },
  [TaxCodes.WEBSITE_INFO_BUSINESS]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WEBSITE_INFO_BUSINESS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WEBSITE_INFO_BUSINESS}.name`),
  },
  [TaxCodes.WEBSITE_INFO_PERSONAL]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WEBSITE_INFO_PERSONAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WEBSITE_INFO_PERSONAL}.name`),
  },
  [TaxCodes.ELECTRONIC_INFO_BUSINESS]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ELECTRONIC_INFO_BUSINESS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ELECTRONIC_INFO_BUSINESS}.name`),
  },
  [TaxCodes.ELECTRONIC_INFO_PERSONAL]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ELECTRONIC_INFO_PERSONAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ELECTRONIC_INFO_PERSONAL}.name`),
  },
  [TaxCodes.ONLINE_DATING]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ONLINE_DATING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ONLINE_DATING}.name`),
  },
  [TaxCodes.AUDIOVISUAL_BUNDLE_DOWNLOAD_STREAM]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(
      `taxcode.${TaxCodes.AUDIOVISUAL_BUNDLE_DOWNLOAD_STREAM}.description`,
    ),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIOVISUAL_BUNDLE_DOWNLOAD_STREAM}.name`),
  },
  [TaxCodes.AUDIOVISUAL_BUNDLE_DOWNLOAD_LIMITED]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(
      `taxcode.${TaxCodes.AUDIOVISUAL_BUNDLE_DOWNLOAD_LIMITED}.description`,
    ),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIOVISUAL_BUNDLE_DOWNLOAD_LIMITED}.name`),
  },
  [TaxCodes.AUDIOVISUAL_BUNDLE_DOWNLOAD_PERMANENT]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(
      `taxcode.${TaxCodes.AUDIOVISUAL_BUNDLE_DOWNLOAD_PERMANENT}.description`,
    ),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIOVISUAL_BUNDLE_DOWNLOAD_PERMANENT}.name`),
  },
  [TaxCodes.AUDIO_BUNDLE_DOWNLOAD_STREAM]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AUDIO_BUNDLE_DOWNLOAD_STREAM}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIO_BUNDLE_DOWNLOAD_STREAM}.name`),
  },
  [TaxCodes.CAR_WASH]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CAR_WASH}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CAR_WASH}.name`),
  },
  [TaxCodes.CLEANING_PROPERTY]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CLEANING_PROPERTY}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CLEANING_PROPERTY}.name`),
  },
  [TaxCodes.CLEANING_COMMERCIAL]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CLEANING_COMMERCIAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CLEANING_COMMERCIAL}.name`),
  },
  [TaxCodes.CLEANING_RESIDENTIAL]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CLEANING_RESIDENTIAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CLEANING_RESIDENTIAL}.name`),
  },
  [TaxCodes.GUTTER_CLEANING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GUTTER_CLEANING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GUTTER_CLEANING}.name`),
  },
  [TaxCodes.HARDWARE_INSTALL_NONPERMANENT]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HARDWARE_INSTALL_NONPERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HARDWARE_INSTALL_NONPERMANENT}.name`),
  },
  [TaxCodes.HARDWARE_INSTALL_PERMANENT]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HARDWARE_INSTALL_PERMANENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HARDWARE_INSTALL_PERMANENT}.name`),
  },
  [TaxCodes.PROPERTY_INSTALL]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PROPERTY_INSTALL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PROPERTY_INSTALL}.name`),
  },
  [TaxCodes.PET_BOARDING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PET_BOARDING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PET_BOARDING}.name`),
  },
  [TaxCodes.PET_GROOMING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PET_GROOMING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PET_GROOMING}.name`),
  },
  [TaxCodes.PARKING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PARKING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PARKING}.name`),
  },
  [TaxCodes.PET_TRAINING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PET_TRAINING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PET_TRAINING}.name`),
  },
  [TaxCodes.HAIRDRESSING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HAIRDRESSING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HAIRDRESSING}.name`),
  },
  [TaxCodes.PERSONAL_CARE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PERSONAL_CARE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PERSONAL_CARE}.name`),
  },
  [TaxCodes.BODY_PIERCING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BODY_PIERCING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BODY_PIERCING}.name`),
  },
  [TaxCodes.CHILDCARE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CHILDCARE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CHILDCARE}.name`),
  },
  [TaxCodes.DATING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DATING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DATING}.name`),
  },
  [TaxCodes.EMPLOYMENT]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.EMPLOYMENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.EMPLOYMENT}.name`),
  },
  [TaxCodes.MANICURE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MANICURE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MANICURE}.name`),
  },
  [TaxCodes.MASSAGE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MASSAGE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MASSAGE}.name`),
  },
  [TaxCodes.SPA]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SPA}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SPA}.name`),
  },
  [TaxCodes.TANNING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TANNING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TANNING}.name`),
  },
  [TaxCodes.TATTOOING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TATTOOING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TATTOOING}.name`),
  },
  [TaxCodes.PROFESSIONAL]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PROFESSIONAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PROFESSIONAL}.name`),
  },
  [TaxCodes.ACCOUNTING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ACCOUNTING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ACCOUNTING}.name`),
  },
  [TaxCodes.ADVERTISING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ADVERTISING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ADVERTISING}.name`),
  },
  [TaxCodes.CREDIT_REPORTING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CREDIT_REPORTING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CREDIT_REPORTING}.name`),
  },
  [TaxCodes.DATA_PROCESSING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DATA_PROCESSING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DATA_PROCESSING}.name`),
  },
  [TaxCodes.DEBT_COLLECTION]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DEBT_COLLECTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DEBT_COLLECTION}.name`),
  },
  [TaxCodes.ENGINEERING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ENGINEERING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ENGINEERING}.name`),
  },
  [TaxCodes.TECH_SUPPORT]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TECH_SUPPORT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TECH_SUPPORT}.name`),
  },
  [TaxCodes.INSURANCE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INSURANCE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INSURANCE}.name`),
  },
  [TaxCodes.INTERIOR_DECORATING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INTERIOR_DECORATING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INTERIOR_DECORATING}.name`),
  },
  [TaxCodes.LOBBYING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.LOBBYING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.LOBBYING}.name`),
  },
  [TaxCodes.MEDICAL_PROFESSIONAL]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MEDICAL_PROFESSIONAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MEDICAL_PROFESSIONAL}.name`),
  },
  [TaxCodes.PAYROLL]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PAYROLL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PAYROLL}.name`),
  },
  [TaxCodes.PRIVATE_INVESTIGATOR]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PRIVATE_INVESTIGATOR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PRIVATE_INVESTIGATOR}.name`),
  },
  [TaxCodes.SECRETARIAL]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SECRETARIAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SECRETARIAL}.name`),
  },
  [TaxCodes.ELECTRONIC_FILING]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ELECTRONIC_FILING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ELECTRONIC_FILING}.name`),
  },
  [TaxCodes.TEMP_HELP]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TEMP_HELP}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TEMP_HELP}.name`),
  },
  [TaxCodes.TRAINING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TRAINING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TRAINING}.name`),
  },
  [TaxCodes.TRAINING_LIVE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TRAINING_LIVE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TRAINING_LIVE}.name`),
  },
  [TaxCodes.ARCHITECTURAL]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ARCHITECTURAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ARCHITECTURAL}.name`),
  },
  [TaxCodes.CONSULTING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CONSULTING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CONSULTING}.name`),
  },
  [TaxCodes.COSMETIC_MEDICAL]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COSMETIC_MEDICAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COSMETIC_MEDICAL}.name`),
  },
  [TaxCodes.CREDIT_MONITORING]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CREDIT_MONITORING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CREDIT_MONITORING}.name`),
  },
  [TaxCodes.CREDIT_CARD_PROCESSING]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CREDIT_CARD_PROCESSING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CREDIT_CARD_PROCESSING}.name`),
  },
  [TaxCodes.EDUCATIONAL]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.EDUCATIONAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.EDUCATIONAL}.name`),
  },
  [TaxCodes.HOME_INSPECTION]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HOME_INSPECTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HOME_INSPECTION}.name`),
  },
  [TaxCodes.LEGAL]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.LEGAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.LEGAL}.name`),
  },
  [TaxCodes.MARKETING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MARKETING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MARKETING}.name`),
  },
  [TaxCodes.PUBLIC_RELATIONS]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PUBLIC_RELATIONS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PUBLIC_RELATIONS}.name`),
  },
  [TaxCodes.STENOGRAPHIC]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.STENOGRAPHIC}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.STENOGRAPHIC}.name`),
  },
  [TaxCodes.TRAINING_SELF_STUDY]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TRAINING_SELF_STUDY}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TRAINING_SELF_STUDY}.name`),
  },
  [TaxCodes.TUTORING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TUTORING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TUTORING}.name`),
  },
  [TaxCodes.SECURITY_ALARM]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SECURITY_ALARM}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SECURITY_ALARM}.name`),
  },
  [TaxCodes.EXTERMINATION]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.EXTERMINATION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.EXTERMINATION}.name`),
  },
  [TaxCodes.LANDSCAPING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.LANDSCAPING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.LANDSCAPING}.name`),
  },
  [TaxCodes.LAWN_MAINTENANCE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.LAWN_MAINTENANCE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.LAWN_MAINTENANCE}.name`),
  },
  [TaxCodes.PAINTING_WALLPAPERING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PAINTING_WALLPAPERING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PAINTING_WALLPAPERING}.name`),
  },
  [TaxCodes.SECURITY_GUARD]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SECURITY_GUARD}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SECURITY_GUARD}.name`),
  },
  [TaxCodes.PROPERTY_SURVEYING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PROPERTY_SURVEYING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PROPERTY_SURVEYING}.name`),
  },
  [TaxCodes.VEHICLE_REPAIR]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.VEHICLE_REPAIR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.VEHICLE_REPAIR}.name`),
  },
  [TaxCodes.SHOE_REPAIR]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SHOE_REPAIR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SHOE_REPAIR}.name`),
  },
  [TaxCodes.PROPERTY_REPAIR]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PROPERTY_REPAIR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PROPERTY_REPAIR}.name`),
  },
  [TaxCodes.REAL_PROPERTY_REPAIR]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.REAL_PROPERTY_REPAIR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.REAL_PROPERTY_REPAIR}.name`),
  },
  [TaxCodes.AIRCRAFT_REPAIR]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AIRCRAFT_REPAIR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AIRCRAFT_REPAIR}.name`),
  },
  [TaxCodes.APPLIANCE_REPAIR]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.APPLIANCE_REPAIR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.APPLIANCE_REPAIR}.name`),
  },
  [TaxCodes.COMPUTER_REPAIR]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_REPAIR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_REPAIR}.name`),
  },
  [TaxCodes.FURNITURE_REUPHOLSTERING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FURNITURE_REUPHOLSTERING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FURNITURE_REUPHOLSTERING}.name`),
  },
  [TaxCodes.JEWELRY_REPAIR]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.JEWELRY_REPAIR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.JEWELRY_REPAIR}.name`),
  },
  [TaxCodes.MACHINE_REPAIR]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MACHINE_REPAIR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MACHINE_REPAIR}.name`),
  },
  [TaxCodes.GARMENT_ALTER_CONJUNCTION]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GARMENT_ALTER_CONJUNCTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GARMENT_ALTER_CONJUNCTION}.name`),
  },
  [TaxCodes.GARMENT_ALTER_SEPARATE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GARMENT_ALTER_SEPARATE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GARMENT_ALTER_SEPARATE}.name`),
  },
  [TaxCodes.SHREDDING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SHREDDING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SHREDDING}.name`),
  },
  [TaxCodes.DRY_CLEANING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DRY_CLEANING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DRY_CLEANING}.name`),
  },
  [TaxCodes.FABRICATION]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FABRICATION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FABRICATION}.name`),
  },
  [TaxCodes.GIFT_WRAP_CONJUNCTION]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GIFT_WRAP_CONJUNCTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GIFT_WRAP_CONJUNCTION}.name`),
  },
  [TaxCodes.LINEN_LAUNDRY_ONLY]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.LINEN_LAUNDRY_ONLY}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.LINEN_LAUNDRY_ONLY}.name`),
  },
  [TaxCodes.WARRANTY_MANDATORY]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WARRANTY_MANDATORY}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WARRANTY_MANDATORY}.name`),
  },
  [TaxCodes.WARRANTY_OPTIONAL]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WARRANTY_OPTIONAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WARRANTY_OPTIONAL}.name`),
  },
  [TaxCodes.ASSEMBLY_CONJUNCTION]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ASSEMBLY_CONJUNCTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ASSEMBLY_CONJUNCTION}.name`),
  },
  [TaxCodes.ASSEMBLY_PRIOR]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ASSEMBLY_PRIOR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ASSEMBLY_PRIOR}.name`),
  },
  [TaxCodes.DRY_CLEANING_OTHER]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DRY_CLEANING_OTHER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DRY_CLEANING_OTHER}.name`),
  },
  [TaxCodes.GIFT_WRAP_SEPARATE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GIFT_WRAP_SEPARATE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GIFT_WRAP_SEPARATE}.name`),
  },
  [TaxCodes.LINEN_LAUNDRY_ONLY_OTHER]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.LINEN_LAUNDRY_ONLY_OTHER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.LINEN_LAUNDRY_ONLY_OTHER}.name`),
  },
  [TaxCodes.MEAT_PROCESSING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MEAT_PROCESSING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MEAT_PROCESSING}.name`),
  },
  [TaxCodes.PRINTING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PRINTING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PRINTING}.name`),
  },
  [TaxCodes.PRINTING_CUSTOMER_SUPPLIED]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PRINTING_CUSTOMER_SUPPLIED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PRINTING_CUSTOMER_SUPPLIED}.name`),
  },
  [TaxCodes.TAXIDERMY]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TAXIDERMY}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TAXIDERMY}.name`),
  },
  [TaxCodes.ENGRAVING_SEPARATE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ENGRAVING_SEPARATE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ENGRAVING_SEPARATE}.name`),
  },
  [TaxCodes.ENGRAVING_CONJUNCTION]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ENGRAVING_CONJUNCTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ENGRAVING_CONJUNCTION}.name`),
  },
  [TaxCodes.WARRANTY_EXTENDED_VEHICLE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WARRANTY_EXTENDED_VEHICLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WARRANTY_EXTENDED_VEHICLE}.name`),
  },
  [TaxCodes.MAINTENANCE_VEHICLE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MAINTENANCE_VEHICLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MAINTENANCE_VEHICLE}.name`),
  },
  [TaxCodes.WARRANTY_EXTENDED_LEASED_VEHICLE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WARRANTY_EXTENDED_LEASED_VEHICLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WARRANTY_EXTENDED_LEASED_VEHICLE}.name`),
  },
  [TaxCodes.MAINTENANCE_LEASED_VEHICLE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MAINTENANCE_LEASED_VEHICLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MAINTENANCE_LEASED_VEHICLE}.name`),
  },
  [TaxCodes.WARRANTY_EXTENDED_AFTERMARKET]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WARRANTY_EXTENDED_AFTERMARKET}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WARRANTY_EXTENDED_AFTERMARKET}.name`),
  },
  [TaxCodes.MAINTENANCE_AFTERMARKET]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MAINTENANCE_AFTERMARKET}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MAINTENANCE_AFTERMARKET}.name`),
  },
  [TaxCodes.ARMORED_CAR]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ARMORED_CAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ARMORED_CAR}.name`),
  },
  [TaxCodes.CLOTHING_FOOTWEAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CLOTHING_FOOTWEAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CLOTHING_FOOTWEAR}.name`),
  },
  [TaxCodes.BELT_BUCKLE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BELT_BUCKLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BELT_BUCKLE}.name`),
  },
  [TaxCodes.BELTS_SUSPENDERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BELTS_SUSPENDERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BELTS_SUSPENDERS}.name`),
  },
  [TaxCodes.NECK_GAITER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NECK_GAITER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NECK_GAITER}.name`),
  },
  [TaxCodes.SCHOOL_UNIFORMS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SCHOOL_UNIFORMS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SCHOOL_UNIFORMS}.name`),
  },
  [TaxCodes.FUR_CLOTHING_SYNTHETIC]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FUR_CLOTHING_SYNTHETIC}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FUR_CLOTHING_SYNTHETIC}.name`),
  },
  [TaxCodes.SCARVES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SCARVES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SCARVES}.name`),
  },
  [TaxCodes.NECKTIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NECKTIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NECKTIES}.name`),
  },
  [TaxCodes.FORMAL_WEAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FORMAL_WEAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FORMAL_WEAR}.name`),
  },
  [TaxCodes.CHILDRENS_CLOTHING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CHILDRENS_CLOTHING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CHILDRENS_CLOTHING}.name`),
  },
  [TaxCodes.FUR_CLOTHING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FUR_CLOTHING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FUR_CLOTHING}.name`),
  },
  [TaxCodes.ATHLETIC_CLOTHING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ATHLETIC_CLOTHING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ATHLETIC_CLOTHING}.name`),
  },
  [TaxCodes.SWEAT_BANDS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SWEAT_BANDS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SWEAT_BANDS}.name`),
  },
  [TaxCodes.SWIMSUITS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SWIMSUITS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SWIMSUITS}.name`),
  },
  [TaxCodes.OCCUPATIONAL_UNIFORMS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.OCCUPATIONAL_UNIFORMS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.OCCUPATIONAL_UNIFORMS}.name`),
  },
  [TaxCodes.CLEANROOM_APPAREL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CLEANROOM_APPAREL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CLEANROOM_APPAREL}.name`),
  },
  [TaxCodes.REFLECTIVE_APPAREL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.REFLECTIVE_APPAREL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.REFLECTIVE_APPAREL}.name`),
  },
  [TaxCodes.PROTECTIVE_SAFETY_CLOTHING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PROTECTIVE_SAFETY_CLOTHING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PROTECTIVE_SAFETY_CLOTHING}.name`),
  },
  [TaxCodes.PROTECTIVE_SAFETY_CLOTHING_OCCUPATIONAL_USE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(
      `taxcode.${TaxCodes.PROTECTIVE_SAFETY_CLOTHING_OCCUPATIONAL_USE}.description`,
    ),
    name: i18n.global.t(`taxcode.${TaxCodes.PROTECTIVE_SAFETY_CLOTHING_OCCUPATIONAL_USE}.name`),
  },
  [TaxCodes.PROTECTIVE_SAFETY_FOOTWEAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PROTECTIVE_SAFETY_FOOTWEAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PROTECTIVE_SAFETY_FOOTWEAR}.name`),
  },
  [TaxCodes.PROTECTIVE_SAFETY_FOOTWEAR_OCCUPATIONAL_USE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(
      `taxcode.${TaxCodes.PROTECTIVE_SAFETY_FOOTWEAR_OCCUPATIONAL_USE}.description`,
    ),
    name: i18n.global.t(`taxcode.${TaxCodes.PROTECTIVE_SAFETY_FOOTWEAR_OCCUPATIONAL_USE}.name`),
  },
  [TaxCodes.PROTECTIVE_SAFETY_EQUIPMENT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PROTECTIVE_SAFETY_EQUIPMENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PROTECTIVE_SAFETY_EQUIPMENT}.name`),
  },
  [TaxCodes.PROTECTIVE_SAFETY_EQUIPMENT_OCCUPATIONAL_USE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(
      `taxcode.${TaxCodes.PROTECTIVE_SAFETY_EQUIPMENT_OCCUPATIONAL_USE}.description`,
    ),
    name: i18n.global.t(`taxcode.${TaxCodes.PROTECTIVE_SAFETY_EQUIPMENT_OCCUPATIONAL_USE}.name`),
  },
  [TaxCodes.CLOTH_FACE_MASKS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CLOTH_FACE_MASKS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CLOTH_FACE_MASKS}.name`),
  },
  [TaxCodes.COSTUME_MASKS_AND_ACCESSORIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COSTUME_MASKS_AND_ACCESSORIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COSTUME_MASKS_AND_ACCESSORIES}.name`),
  },
  [TaxCodes.COSTUMES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COSTUMES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COSTUMES}.name`),
  },
  [TaxCodes.GLOVES_GENERAL_USE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GLOVES_GENERAL_USE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GLOVES_GENERAL_USE}.name`),
  },
  [TaxCodes.PURSES_AND_HANDBAGS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PURSES_AND_HANDBAGS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PURSES_AND_HANDBAGS}.name`),
  },
  [TaxCodes.HANDKERCHIEFS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HANDKERCHIEFS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HANDKERCHIEFS}.name`),
  },
  [TaxCodes.HAIR_ACCESSORIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HAIR_ACCESSORIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HAIR_ACCESSORIES}.name`),
  },
  [TaxCodes.HATS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HATS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HATS}.name`),
  },
  [TaxCodes.JEWELRY]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.JEWELRY}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.JEWELRY}.name`),
  },
  [TaxCodes.NON_CLOTHING_ACCESSORIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NON_CLOTHING_ACCESSORIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NON_CLOTHING_ACCESSORIES}.name`),
  },
  [TaxCodes.SHOWER_CAPS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SHOWER_CAPS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SHOWER_CAPS}.name`),
  },
  [TaxCodes.UMBRELLAS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.UMBRELLAS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.UMBRELLAS}.name`),
  },
  [TaxCodes.WIGS_HAIRPIECES_HAIR_EXTENSIONS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WIGS_HAIRPIECES_HAIR_EXTENSIONS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WIGS_HAIRPIECES_HAIR_EXTENSIONS}.name`),
  },
  [TaxCodes.LUGGAGE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.LUGGAGE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.LUGGAGE}.name`),
  },
  [TaxCodes.WATCHES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WATCHES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WATCHES}.name`),
  },
  [TaxCodes.SUNGLASSES_NON_PRESCRIPTION]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SUNGLASSES_NON_PRESCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SUNGLASSES_NON_PRESCRIPTION}.name`),
  },
  [TaxCodes.WATCHES_SMART]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WATCHES_SMART}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WATCHES_SMART}.name`),
  },
  [TaxCodes.BRIEFCASES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BRIEFCASES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BRIEFCASES}.name`),
  },
  [TaxCodes.APRONS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.APRONS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.APRONS}.name`),
  },
  [TaxCodes.BANDANNAS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BANDANNAS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BANDANNAS}.name`),
  },
  [TaxCodes.WALLETS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WALLETS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WALLETS}.name`),
  },
  [TaxCodes.BICYCLE_HELMETS_ADULT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BICYCLE_HELMETS_ADULT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BICYCLE_HELMETS_ADULT}.name`),
  },
  [TaxCodes.BICYCLE_HELMETS_YOUTH]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BICYCLE_HELMETS_YOUTH}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BICYCLE_HELMETS_YOUTH}.name`),
  },
  [TaxCodes.BALLET_TAP_SHOES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BALLET_TAP_SHOES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BALLET_TAP_SHOES}.name`),
  },
  [TaxCodes.BASEBALL_BATTING_GLOVES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BASEBALL_BATTING_GLOVES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BASEBALL_BATTING_GLOVES}.name`),
  },
  [TaxCodes.BOWLING_GLOVES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BOWLING_GLOVES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BOWLING_GLOVES}.name`),
  },
  [TaxCodes.BOWLING_SHOES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BOWLING_SHOES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BOWLING_SHOES}.name`),
  },
  [TaxCodes.BOXING_GLOVES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BOXING_GLOVES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BOXING_GLOVES}.name`),
  },
  [TaxCodes.CLEATED_SPIKED_SHOES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CLEATED_SPIKED_SHOES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CLEATED_SPIKED_SHOES}.name`),
  },
  [TaxCodes.FOOTBALL_RECEIVER_GLOVES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOTBALL_RECEIVER_GLOVES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOTBALL_RECEIVER_GLOVES}.name`),
  },
  [TaxCodes.GOLF_GLOVES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GOLF_GLOVES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GOLF_GLOVES}.name`),
  },
  [TaxCodes.GOLF_SHOES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GOLF_SHOES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GOLF_SHOES}.name`),
  },
  [TaxCodes.ICE_SKATES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ICE_SKATES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ICE_SKATES}.name`),
  },
  [TaxCodes.LIFE_VESTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.LIFE_VESTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.LIFE_VESTS}.name`),
  },
  [TaxCodes.MARTIAL_ARTS_ATTIRE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MARTIAL_ARTS_ATTIRE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MARTIAL_ARTS_ATTIRE}.name`),
  },
  [TaxCodes.MOTORCYCLE_HELMETS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MOTORCYCLE_HELMETS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MOTORCYCLE_HELMETS}.name`),
  },
  [TaxCodes.MOUTH_GUARDS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MOUTH_GUARDS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MOUTH_GUARDS}.name`),
  },
  [TaxCodes.ROLLER_SKATES_BLADES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ROLLER_SKATES_BLADES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ROLLER_SKATES_BLADES}.name`),
  },
  [TaxCodes.SHIN_GUARDS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SHIN_GUARDS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SHIN_GUARDS}.name`),
  },
  [TaxCodes.SHOULDER_PADS_SPORTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SHOULDER_PADS_SPORTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SHOULDER_PADS_SPORTS}.name`),
  },
  [TaxCodes.SKI_BOOTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SKI_BOOTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SKI_BOOTS}.name`),
  },
  [TaxCodes.SPORT_UNIFORMS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SPORT_UNIFORMS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SPORT_UNIFORMS}.name`),
  },
  [TaxCodes.SWIM_FINS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SWIM_FINS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SWIM_FINS}.name`),
  },
  [TaxCodes.SWIM_GOGGLES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SWIM_GOGGLES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SWIM_GOGGLES}.name`),
  },
  [TaxCodes.WETSUIT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WETSUIT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WETSUIT}.name`),
  },
  [TaxCodes.ATHLETIC_SUPPORTER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ATHLETIC_SUPPORTER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ATHLETIC_SUPPORTER}.name`),
  },
  [TaxCodes.HUNTING_VESTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HUNTING_VESTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HUNTING_VESTS}.name`),
  },
  [TaxCodes.HUNTING_CLOTHING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HUNTING_CLOTHING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HUNTING_CLOTHING}.name`),
  },
  [TaxCodes.SPORTS_EQUIPMENT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SPORTS_EQUIPMENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SPORTS_EQUIPMENT}.name`),
  },
  [TaxCodes.BUTTON_COVERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BUTTON_COVERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BUTTON_COVERS}.name`),
  },
  [TaxCodes.COMPONENT_CLOTHING_ITEMS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COMPONENT_CLOTHING_ITEMS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COMPONENT_CLOTHING_ITEMS}.name`),
  },
  [TaxCodes.OVERSHOES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.OVERSHOES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.OVERSHOES}.name`),
  },
  [TaxCodes.SHOE_INSERTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SHOE_INSERTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SHOE_INSERTS}.name`),
  },
  [TaxCodes.SHOELACES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SHOELACES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SHOELACES}.name`),
  },
  [TaxCodes.BIBS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BIBS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BIBS}.name`),
  },
  [TaxCodes.INFANT_SWADDLES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INFANT_SWADDLES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INFANT_SWADDLES}.name`),
  },
  [TaxCodes.INFANT_RECEIVING_BLANKETS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INFANT_RECEIVING_BLANKETS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INFANT_RECEIVING_BLANKETS}.name`),
  },
  [TaxCodes.DIAPER_CREAM]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DIAPER_CREAM}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DIAPER_CREAM}.name`),
  },
  [TaxCodes.BABY_WIPES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BABY_WIPES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BABY_WIPES}.name`),
  },
  [TaxCodes.INFANT_DIAPERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INFANT_DIAPERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INFANT_DIAPERS}.name`),
  },
  [TaxCodes.TODDLER_TRAINING_PANTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TODDLER_TRAINING_PANTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TODDLER_TRAINING_PANTS}.name`),
  },
  [TaxCodes.DIAPER_LINERS_SINGLE_USE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DIAPER_LINERS_SINGLE_USE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DIAPER_LINERS_SINGLE_USE}.name`),
  },
  [TaxCodes.CLOTH_DIAPERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CLOTH_DIAPERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CLOTH_DIAPERS}.name`),
  },
  [TaxCodes.BABY_BOTTLES_NIPPLES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BABY_BOTTLES_NIPPLES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BABY_BOTTLES_NIPPLES}.name`),
  },
  [TaxCodes.BREAST_PUMPS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BREAST_PUMPS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BREAST_PUMPS}.name`),
  },
  [TaxCodes.INFANT_CAR_SEAT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INFANT_CAR_SEAT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INFANT_CAR_SEAT}.name`),
  },
  [TaxCodes.BLOOD_GLUCOSE_MONITOR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BLOOD_GLUCOSE_MONITOR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BLOOD_GLUCOSE_MONITOR}.name`),
  },
  [TaxCodes.DIABETIC_TEST_SUPPLIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DIABETIC_TEST_SUPPLIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DIABETIC_TEST_SUPPLIES}.name`),
  },
  [TaxCodes.BLOOD_GLUCOSE_MONITOR_PRESCRIPTION]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(
      `taxcode.${TaxCodes.BLOOD_GLUCOSE_MONITOR_PRESCRIPTION}.description`,
    ),
    name: i18n.global.t(`taxcode.${TaxCodes.BLOOD_GLUCOSE_MONITOR_PRESCRIPTION}.name`),
  },
  [TaxCodes.DIABETIC_TEST_SUPPLIES_PRESCRIPTION]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(
      `taxcode.${TaxCodes.DIABETIC_TEST_SUPPLIES_PRESCRIPTION}.description`,
    ),
    name: i18n.global.t(`taxcode.${TaxCodes.DIABETIC_TEST_SUPPLIES_PRESCRIPTION}.name`),
  },
  [TaxCodes.PRESCRIPTION_DRUGS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PRESCRIPTION_DRUGS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PRESCRIPTION_DRUGS}.name`),
  },
  [TaxCodes.OTC_DRUGS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.OTC_DRUGS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.OTC_DRUGS}.name`),
  },
  [TaxCodes.OTC_DRUGS_PRESCRIPTION]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.OTC_DRUGS_PRESCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.OTC_DRUGS_PRESCRIPTION}.name`),
  },
  [TaxCodes.INSULIN_PRESCRIPTION]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INSULIN_PRESCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INSULIN_PRESCRIPTION}.name`),
  },
  [TaxCodes.INSULIN]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INSULIN}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INSULIN}.name`),
  },
  [TaxCodes.MEDICAL_OXYGEN_PRESCRIPTION]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MEDICAL_OXYGEN_PRESCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MEDICAL_OXYGEN_PRESCRIPTION}.name`),
  },
  [TaxCodes.MEDICAL_OXYGEN]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MEDICAL_OXYGEN}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MEDICAL_OXYGEN}.name`),
  },
  [TaxCodes.CONDOMS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CONDOMS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CONDOMS}.name`),
  },
  [TaxCodes.CONDOMS_PRESCRIPTION]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CONDOMS_PRESCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CONDOMS_PRESCRIPTION}.name`),
  },
  [TaxCodes.CONDOMS_SPERMICIDE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CONDOMS_SPERMICIDE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CONDOMS_SPERMICIDE}.name`),
  },
  [TaxCodes.CONDOMS_SPERMICIDE_PRESCRIPTION]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CONDOMS_SPERMICIDE_PRESCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CONDOMS_SPERMICIDE_PRESCRIPTION}.name`),
  },
  [TaxCodes.CONTRACEPTIVE_OINTMENTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CONTRACEPTIVE_OINTMENTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CONTRACEPTIVE_OINTMENTS}.name`),
  },
  [TaxCodes.BIRTH_CONTROL_OTC_ORAL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BIRTH_CONTROL_OTC_ORAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BIRTH_CONTROL_OTC_ORAL}.name`),
  },
  [TaxCodes.BIRTH_CONTROL_OTC_ORAL_PRESCRIPTION]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(
      `taxcode.${TaxCodes.BIRTH_CONTROL_OTC_ORAL_PRESCRIPTION}.description`,
    ),
    name: i18n.global.t(`taxcode.${TaxCodes.BIRTH_CONTROL_OTC_ORAL_PRESCRIPTION}.name`),
  },
  [TaxCodes.BIRTH_CONTROL_PRESCRIPTION_BARRIERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(
      `taxcode.${TaxCodes.BIRTH_CONTROL_PRESCRIPTION_BARRIERS}.description`,
    ),
    name: i18n.global.t(`taxcode.${TaxCodes.BIRTH_CONTROL_PRESCRIPTION_BARRIERS}.name`),
  },
  [TaxCodes.BIRTH_CONTROL_PRESCRIPTION_HORMONAL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(
      `taxcode.${TaxCodes.BIRTH_CONTROL_PRESCRIPTION_HORMONAL}.description`,
    ),
    name: i18n.global.t(`taxcode.${TaxCodes.BIRTH_CONTROL_PRESCRIPTION_HORMONAL}.name`),
  },
  [TaxCodes.BIRTH_CONTROL_PRESCRIPTION_ORAL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BIRTH_CONTROL_PRESCRIPTION_ORAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BIRTH_CONTROL_PRESCRIPTION_ORAL}.name`),
  },
  [TaxCodes.FEMININE_CLEANSING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FEMININE_CLEANSING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FEMININE_CLEANSING}.name`),
  },
  [TaxCodes.FEMININE_CLEANSING_MEDICATED]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FEMININE_CLEANSING_MEDICATED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FEMININE_CLEANSING_MEDICATED}.name`),
  },
  [TaxCodes.FEMININE_YEAST_TREATMENTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FEMININE_YEAST_TREATMENTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FEMININE_YEAST_TREATMENTS}.name`),
  },
  [TaxCodes.TAMPONS_PADS_LINERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TAMPONS_PADS_LINERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TAMPONS_PADS_LINERS}.name`),
  },
  [TaxCodes.ADULT_DIAPERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ADULT_DIAPERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ADULT_DIAPERS}.name`),
  },
  [TaxCodes.DISPOSABLE_FACE_MASKS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DISPOSABLE_FACE_MASKS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DISPOSABLE_FACE_MASKS}.name`),
  },
  [TaxCodes.GROOMING_HYGIENE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GROOMING_HYGIENE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GROOMING_HYGIENE}.name`),
  },
  [TaxCodes.GROOMING_HYGIENE_MEDICATED]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GROOMING_HYGIENE_MEDICATED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GROOMING_HYGIENE_MEDICATED}.name`),
  },
  [TaxCodes.HAND_SANITIZERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HAND_SANITIZERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HAND_SANITIZERS}.name`),
  },
  [TaxCodes.MEDICATED_ACNE_TREATMENTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MEDICATED_ACNE_TREATMENTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MEDICATED_ACNE_TREATMENTS}.name`),
  },
  [TaxCodes.SKIN_CARE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SKIN_CARE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SKIN_CARE}.name`),
  },
  [TaxCodes.SKIN_CARE_MEDICATED]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SKIN_CARE_MEDICATED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SKIN_CARE_MEDICATED}.name`),
  },
  [TaxCodes.SMOKING_CESSATION]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SMOKING_CESSATION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SMOKING_CESSATION}.name`),
  },
  [TaxCodes.TOILET_TISSUE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TOILET_TISSUE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TOILET_TISSUE}.name`),
  },
  [TaxCodes.TOOTHBRUSH]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TOOTHBRUSH}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TOOTHBRUSH}.name`),
  },
  [TaxCodes.TOOTHPASTE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TOOTHPASTE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TOOTHPASTE}.name`),
  },
  [TaxCodes.BABY_OIL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BABY_OIL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BABY_OIL}.name`),
  },
  [TaxCodes.BABY_POWDER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BABY_POWDER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BABY_POWDER}.name`),
  },
  [TaxCodes.BREATH_SPRAY_STRIPS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BREATH_SPRAY_STRIPS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BREATH_SPRAY_STRIPS}.name`),
  },
  [TaxCodes.BUBBLE_BATH_SALTS_OILS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BUBBLE_BATH_SALTS_OILS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BUBBLE_BATH_SALTS_OILS}.name`),
  },
  [TaxCodes.CONDITIONER_HAIR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CONDITIONER_HAIR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CONDITIONER_HAIR}.name`),
  },
  [TaxCodes.COSMETICS_BEAUTIFYING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COSMETICS_BEAUTIFYING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COSMETICS_BEAUTIFYING}.name`),
  },
  [TaxCodes.DENTAL_FLOSS_PICKS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DENTAL_FLOSS_PICKS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DENTAL_FLOSS_PICKS}.name`),
  },
  [TaxCodes.DENTURE_CREAMS_ADHESIVES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DENTURE_CREAMS_ADHESIVES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DENTURE_CREAMS_ADHESIVES}.name`),
  },
  [TaxCodes.DEODORANT_NATURAL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DEODORANT_NATURAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DEODORANT_NATURAL}.name`),
  },
  [TaxCodes.DEODORANT_ANTIPERSPIRANT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DEODORANT_ANTIPERSPIRANT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DEODORANT_ANTIPERSPIRANT}.name`),
  },
  [TaxCodes.HAIR_LOSS_PRODUCTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HAIR_LOSS_PRODUCTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HAIR_LOSS_PRODUCTS}.name`),
  },
  [TaxCodes.HAIR_REMOVAL_PRODUCTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HAIR_REMOVAL_PRODUCTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HAIR_REMOVAL_PRODUCTS}.name`),
  },
  [TaxCodes.LIP_BALM]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.LIP_BALM}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.LIP_BALM}.name`),
  },
  [TaxCodes.LIP_BALM_MEDICATED]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.LIP_BALM_MEDICATED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.LIP_BALM_MEDICATED}.name`),
  },
  [TaxCodes.MOUTHWASH_COSMETIC]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MOUTHWASH_COSMETIC}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MOUTHWASH_COSMETIC}.name`),
  },
  [TaxCodes.MOUTHWASH_THERAPEUTIC]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MOUTHWASH_THERAPEUTIC}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MOUTHWASH_THERAPEUTIC}.name`),
  },
  [TaxCodes.SHAMPOO]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SHAMPOO}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SHAMPOO}.name`),
  },
  [TaxCodes.SHAMPOO_MEDICATED]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SHAMPOO_MEDICATED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SHAMPOO_MEDICATED}.name`),
  },
  [TaxCodes.SHAVING_CREAMS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SHAVING_CREAMS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SHAVING_CREAMS}.name`),
  },
  [TaxCodes.SOAPS_ANTIBACTERIAL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SOAPS_ANTIBACTERIAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SOAPS_ANTIBACTERIAL}.name`),
  },
  [TaxCodes.SUNSCREEN]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SUNSCREEN}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SUNSCREEN}.name`),
  },
  [TaxCodes.TEETH_WHITENING_KITS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TEETH_WHITENING_KITS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TEETH_WHITENING_KITS}.name`),
  },
  [TaxCodes.DURABLE_MEDICAL_EQUIPMENT_HOME]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DURABLE_MEDICAL_EQUIPMENT_HOME}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DURABLE_MEDICAL_EQUIPMENT_HOME}.name`),
  },
  [TaxCodes.MEDICAL_EQUIPMENT_HOME_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MEDICAL_EQUIPMENT_HOME_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MEDICAL_EQUIPMENT_HOME_RX}.name`),
  },
  [TaxCodes.FEEDING_EQUIPMENT_HOME_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FEEDING_EQUIPMENT_HOME_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FEEDING_EQUIPMENT_HOME_RX}.name`),
  },
  [TaxCodes.DIALYSIS_EQUIPMENT_HOME_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DIALYSIS_EQUIPMENT_HOME_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DIALYSIS_EQUIPMENT_HOME_RX}.name`),
  },
  [TaxCodes.DIALYSIS_EQUIPMENT_HOME]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DIALYSIS_EQUIPMENT_HOME}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DIALYSIS_EQUIPMENT_HOME}.name`),
  },
  [TaxCodes.OXYGEN_EQUIPMENT_HOME_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.OXYGEN_EQUIPMENT_HOME_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.OXYGEN_EQUIPMENT_HOME_RX}.name`),
  },
  [TaxCodes.OXYGEN_EQUIPMENT_HOME]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.OXYGEN_EQUIPMENT_HOME}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.OXYGEN_EQUIPMENT_HOME}.name`),
  },
  [TaxCodes.HEATING_PADS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HEATING_PADS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HEATING_PADS}.name`),
  },
  [TaxCodes.THERAPY_PACKS_REUSABLE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.THERAPY_PACKS_REUSABLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.THERAPY_PACKS_REUSABLE}.name`),
  },
  [TaxCodes.FEEDING_EQUIPMENT_HOME]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FEEDING_EQUIPMENT_HOME}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FEEDING_EQUIPMENT_HOME}.name`),
  },
  [TaxCodes.WOUND_CARE_BANDAGES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WOUND_CARE_BANDAGES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WOUND_CARE_BANDAGES}.name`),
  },
  [TaxCodes.WOUND_CARE_MEDICATED]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WOUND_CARE_MEDICATED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WOUND_CARE_MEDICATED}.name`),
  },
  [TaxCodes.FIRST_AID_KITS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FIRST_AID_KITS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FIRST_AID_KITS}.name`),
  },
  [TaxCodes.GLOVES_DISPOSABLE_NON_MEDICAL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GLOVES_DISPOSABLE_NON_MEDICAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GLOVES_DISPOSABLE_NON_MEDICAL}.name`),
  },
  [TaxCodes.GLOVES_DISPOSABLE_MEDICAL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GLOVES_DISPOSABLE_MEDICAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GLOVES_DISPOSABLE_MEDICAL}.name`),
  },
  [TaxCodes.MEDICAL_SUPPLIES_CONSUMABLE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MEDICAL_SUPPLIES_CONSUMABLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MEDICAL_SUPPLIES_CONSUMABLE}.name`),
  },
  [TaxCodes.FIRST_AID_KITS_50_OR_LESS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FIRST_AID_KITS_50_OR_LESS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FIRST_AID_KITS_50_OR_LESS}.name`),
  },
  [TaxCodes.CONTACT_LENS_CLEANER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CONTACT_LENS_CLEANER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CONTACT_LENS_CLEANER}.name`),
  },
  [TaxCodes.CONTACT_LENS_LUBRICANT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CONTACT_LENS_LUBRICANT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CONTACT_LENS_LUBRICANT}.name`),
  },
  [TaxCodes.COTTON_SWABS_STERILE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COTTON_SWABS_STERILE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COTTON_SWABS_STERILE}.name`),
  },
  [TaxCodes.COTTON_SWABS_UNSTERILE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COTTON_SWABS_UNSTERILE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COTTON_SWABS_UNSTERILE}.name`),
  },
  [TaxCodes.THERAPY_PACKS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.THERAPY_PACKS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.THERAPY_PACKS}.name`),
  },
  [TaxCodes.THERAPY_PACKS_MEDICATED]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.THERAPY_PACKS_MEDICATED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.THERAPY_PACKS_MEDICATED}.name`),
  },
  [TaxCodes.NASAL_BREATHING_STRIPS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NASAL_BREATHING_STRIPS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NASAL_BREATHING_STRIPS}.name`),
  },
  [TaxCodes.INSULIN_NEEDLES_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INSULIN_NEEDLES_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INSULIN_NEEDLES_RX}.name`),
  },
  [TaxCodes.INSULIN_NEEDLES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INSULIN_NEEDLES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INSULIN_NEEDLES}.name`),
  },
  [TaxCodes.HYDROGEN_PEROXIDE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HYDROGEN_PEROXIDE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HYDROGEN_PEROXIDE}.name`),
  },
  [TaxCodes.PETROLEUM_JELLY]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PETROLEUM_JELLY}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PETROLEUM_JELLY}.name`),
  },
  [TaxCodes.EAR_DROPS_MEDICATED]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.EAR_DROPS_MEDICATED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.EAR_DROPS_MEDICATED}.name`),
  },
  [TaxCodes.ISOPROPYL_RUBBING_ALCOHOL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ISOPROPYL_RUBBING_ALCOHOL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ISOPROPYL_RUBBING_ALCOHOL}.name`),
  },
  [TaxCodes.BATH_AIDS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BATH_AIDS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BATH_AIDS}.name`),
  },
  [TaxCodes.MOBILITY_EQUIPMENT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MOBILITY_EQUIPMENT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MOBILITY_EQUIPMENT}.name`),
  },
  [TaxCodes.MOBILITY_EQUIPMENT_PARTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MOBILITY_EQUIPMENT_PARTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MOBILITY_EQUIPMENT_PARTS}.name`),
  },
  [TaxCodes.MOBILITY_EQUIPMENT_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MOBILITY_EQUIPMENT_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MOBILITY_EQUIPMENT_RX}.name`),
  },
  [TaxCodes.CORRECTIVE_LENSES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CORRECTIVE_LENSES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CORRECTIVE_LENSES}.name`),
  },
  [TaxCodes.HEARING_AID_BATTERIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HEARING_AID_BATTERIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HEARING_AID_BATTERIES}.name`),
  },
  [TaxCodes.HEARING_AIDS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HEARING_AIDS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HEARING_AIDS}.name`),
  },
  [TaxCodes.PROSTHETIC_DEVICE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PROSTHETIC_DEVICE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PROSTHETIC_DEVICE}.name`),
  },
  [TaxCodes.PROSTHETIC_DEVICES_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PROSTHETIC_DEVICES_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PROSTHETIC_DEVICES_RX}.name`),
  },
  [TaxCodes.CORRECTIVE_LENSES_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CORRECTIVE_LENSES_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CORRECTIVE_LENSES_RX}.name`),
  },
  [TaxCodes.CONTACT_LENSES_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CONTACT_LENSES_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CONTACT_LENSES_RX}.name`),
  },
  [TaxCodes.DENTAL_PROSTHETICS_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DENTAL_PROSTHETICS_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DENTAL_PROSTHETICS_RX}.name`),
  },
  [TaxCodes.DENTAL_PROSTHETICS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DENTAL_PROSTHETICS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DENTAL_PROSTHETICS}.name`),
  },
  [TaxCodes.HEARING_AIDS_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HEARING_AIDS_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HEARING_AIDS_RX}.name`),
  },
  [TaxCodes.HEARING_AID_BATTERIES_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HEARING_AID_BATTERIES_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HEARING_AID_BATTERIES_RX}.name`),
  },
  [TaxCodes.PREGNANCY_TESTING_KITS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PREGNANCY_TESTING_KITS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PREGNANCY_TESTING_KITS}.name`),
  },
  [TaxCodes.OVULATION_TESTING_KITS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.OVULATION_TESTING_KITS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.OVULATION_TESTING_KITS}.name`),
  },
  [TaxCodes.INFECTIOUS_DISEASE_TEST]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INFECTIOUS_DISEASE_TEST}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INFECTIOUS_DISEASE_TEST}.name`),
  },
  [TaxCodes.INFECTIOUS_DISEASE_TEST_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INFECTIOUS_DISEASE_TEST_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INFECTIOUS_DISEASE_TEST_RX}.name`),
  },
  [TaxCodes.DNA_TESTING_KITS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DNA_TESTING_KITS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DNA_TESTING_KITS}.name`),
  },
  [TaxCodes.THERMOMETERS_DISPOSABLE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.THERMOMETERS_DISPOSABLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.THERMOMETERS_DISPOSABLE}.name`),
  },
  [TaxCodes.THERMOMETERS_REUSABLE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.THERMOMETERS_REUSABLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.THERMOMETERS_REUSABLE}.name`),
  },
  [TaxCodes.ENERGY_STAR_PRODUCTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ENERGY_STAR_PRODUCTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ENERGY_STAR_PRODUCTS}.name`),
  },
  [TaxCodes.BLOOD_PRESSURE_DEVICES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BLOOD_PRESSURE_DEVICES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BLOOD_PRESSURE_DEVICES}.name`),
  },
  [TaxCodes.PULSE_OXIMETER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PULSE_OXIMETER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PULSE_OXIMETER}.name`),
  },
  [TaxCodes.DRUG_TESTING_KITS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DRUG_TESTING_KITS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DRUG_TESTING_KITS}.name`),
  },
  [TaxCodes.CHOLESTEROL_TESTING_KITS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CHOLESTEROL_TESTING_KITS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CHOLESTEROL_TESTING_KITS}.name`),
  },
  [TaxCodes.CEILING_FANS_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CEILING_FANS_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CEILING_FANS_ENERGY_STAR}.name`),
  },
  [TaxCodes.AIR_CONDITIONERS_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AIR_CONDITIONERS_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AIR_CONDITIONERS_ENERGY_STAR}.name`),
  },
  [TaxCodes.FURNACES_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FURNACES_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FURNACES_ENERGY_STAR}.name`),
  },
  [TaxCodes.HEAT_PUMPS_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HEAT_PUMPS_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HEAT_PUMPS_ENERGY_STAR}.name`),
  },
  [TaxCodes.WATER_HEATER_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WATER_HEATER_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WATER_HEATER_ENERGY_STAR}.name`),
  },
  [TaxCodes.DEHUMIDIFIER_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DEHUMIDIFIER_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DEHUMIDIFIER_ENERGY_STAR}.name`),
  },
  [TaxCodes.BOILERS_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BOILERS_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BOILERS_ENERGY_STAR}.name`),
  },
  [TaxCodes.THERMOSTAT_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.THERMOSTAT_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.THERMOSTAT_ENERGY_STAR}.name`),
  },
  [TaxCodes.REFRIGERATORS_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.REFRIGERATORS_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.REFRIGERATORS_ENERGY_STAR}.name`),
  },
  [TaxCodes.DISHWASHERS_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DISHWASHERS_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DISHWASHERS_ENERGY_STAR}.name`),
  },
  [TaxCodes.FREEZERS_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FREEZERS_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FREEZERS_ENERGY_STAR}.name`),
  },
  [TaxCodes.WASHING_MACHINE_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WASHING_MACHINE_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WASHING_MACHINE_ENERGY_STAR}.name`),
  },
  [TaxCodes.DRYING_MACHINE_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DRYING_MACHINE_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DRYING_MACHINE_ENERGY_STAR}.name`),
  },
  [TaxCodes.CAN_OPENER_MANUAL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CAN_OPENER_MANUAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CAN_OPENER_MANUAL}.name`),
  },
  [TaxCodes.WATER_EFFICIENT_PRODUCTS_RESIDENTIAL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(
      `taxcode.${TaxCodes.WATER_EFFICIENT_PRODUCTS_RESIDENTIAL}.description`,
    ),
    name: i18n.global.t(`taxcode.${TaxCodes.WATER_EFFICIENT_PRODUCTS_RESIDENTIAL}.name`),
  },
  [TaxCodes.ALKALINE_BATTERIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ALKALINE_BATTERIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ALKALINE_BATTERIES}.name`),
  },
  [TaxCodes.MOBILE_PHONE_BATTERIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MOBILE_PHONE_BATTERIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MOBILE_PHONE_BATTERIES}.name`),
  },
  [TaxCodes.DISINFECTANT_WIPES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DISINFECTANT_WIPES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DISINFECTANT_WIPES}.name`),
  },
  [TaxCodes.DISPOSABLE_PAPER_PRODUCTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DISPOSABLE_PAPER_PRODUCTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DISPOSABLE_PAPER_PRODUCTS}.name`),
  },
  [TaxCodes.HOUSEHOLD_LINENS_BEDDING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HOUSEHOLD_LINENS_BEDDING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HOUSEHOLD_LINENS_BEDDING}.name`),
  },
  [TaxCodes.BEDDING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BEDDING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BEDDING}.name`),
  },
  [TaxCodes.BATH_MATS_RUGS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BATH_MATS_RUGS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BATH_MATS_RUGS}.name`),
  },
  [TaxCodes.BATH_TOWELS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BATH_TOWELS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BATH_TOWELS}.name`),
  },
  [TaxCodes.SHOWER_CURTAIN_LINER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SHOWER_CURTAIN_LINER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SHOWER_CURTAIN_LINER}.name`),
  },
  [TaxCodes.CRIB_BUMPERS_LINERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CRIB_BUMPERS_LINERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CRIB_BUMPERS_LINERS}.name`),
  },
  [TaxCodes.DISH_TOWELS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DISH_TOWELS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DISH_TOWELS}.name`),
  },
  [TaxCodes.YARN_NON_CLOTHING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.YARN_NON_CLOTHING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.YARN_NON_CLOTHING}.name`),
  },
  [TaxCodes.LANDSCAPE_SOIL_MULCH_RESIDENTIAL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.LANDSCAPE_SOIL_MULCH_RESIDENTIAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.LANDSCAPE_SOIL_MULCH_RESIDENTIAL}.name`),
  },
  [TaxCodes.GARDEN_CHEMICALS_NONCOMMERCIAL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GARDEN_CHEMICALS_NONCOMMERCIAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GARDEN_CHEMICALS_NONCOMMERCIAL}.name`),
  },
  [TaxCodes.GARDEN_FERTILIZER_NONCOMMERCIAL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GARDEN_FERTILIZER_NONCOMMERCIAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GARDEN_FERTILIZER_NONCOMMERCIAL}.name`),
  },
  [TaxCodes.INCANDESCENT_BULBS_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INCANDESCENT_BULBS_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INCANDESCENT_BULBS_ENERGY_STAR}.name`),
  },
  [TaxCodes.FLUORESCENT_BULBS_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FLUORESCENT_BULBS_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FLUORESCENT_BULBS_ENERGY_STAR}.name`),
  },
  [TaxCodes.LED_BULBS_ENERGY_STAR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.LED_BULBS_ENERGY_STAR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.LED_BULBS_ENERGY_STAR}.name`),
  },
  [TaxCodes.PORTABLE_LIGHT_SOURCES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PORTABLE_LIGHT_SOURCES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PORTABLE_LIGHT_SOURCES}.name`),
  },
  [TaxCodes.CANDLES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CANDLES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CANDLES}.name`),
  },
  [TaxCodes.STORM_PREPAREDNESS_ITEMS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.STORM_PREPAREDNESS_ITEMS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.STORM_PREPAREDNESS_ITEMS}.name`),
  },
  [TaxCodes.PORTABLE_RADIOS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PORTABLE_RADIOS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PORTABLE_RADIOS}.name`),
  },
  [TaxCodes.FOOD_STORAGE_COOLER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_STORAGE_COOLER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_STORAGE_COOLER}.name`),
  },
  [TaxCodes.SMOKE_DETECTORS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SMOKE_DETECTORS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SMOKE_DETECTORS}.name`),
  },
  [TaxCodes.CARBON_MONOXIDE_DETECTORS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CARBON_MONOXIDE_DETECTORS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CARBON_MONOXIDE_DETECTORS}.name`),
  },
  [TaxCodes.FIRE_EXTINGUISHERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FIRE_EXTINGUISHERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FIRE_EXTINGUISHERS}.name`),
  },
  [TaxCodes.PORTABLE_FUEL_CONTAINER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PORTABLE_FUEL_CONTAINER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PORTABLE_FUEL_CONTAINER}.name`),
  },
  [TaxCodes.WATER_STORAGE_CONTAINER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WATER_STORAGE_CONTAINER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WATER_STORAGE_CONTAINER}.name`),
  },
  [TaxCodes.ARTIFICIAL_ICE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ARTIFICIAL_ICE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ARTIFICIAL_ICE}.name`),
  },
  [TaxCodes.TARPAULINS_WEATHERPROOF_SHEETING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TARPAULINS_WEATHERPROOF_SHEETING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TARPAULINS_WEATHERPROOF_SHEETING}.name`),
  },
  [TaxCodes.PORTABLE_GENERATOR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PORTABLE_GENERATOR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PORTABLE_GENERATOR}.name`),
  },
  [TaxCodes.POWER_CORDS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.POWER_CORDS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.POWER_CORDS}.name`),
  },
  [TaxCodes.AXES_HATCHETS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AXES_HATCHETS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AXES_HATCHETS}.name`),
  },
  [TaxCodes.GARDEN_CHAINSAW]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GARDEN_CHAINSAW}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GARDEN_CHAINSAW}.name`),
  },
  [TaxCodes.CHAINSAW_ACCESSORIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CHAINSAW_ACCESSORIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CHAINSAW_ACCESSORIES}.name`),
  },
  [TaxCodes.STORM_SHUTTERS_WINDOW_PROTECTION]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.STORM_SHUTTERS_WINDOW_PROTECTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.STORM_SHUTTERS_WINDOW_PROTECTION}.name`),
  },
  [TaxCodes.EMERGENCY_RESCUE_LADDER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.EMERGENCY_RESCUE_LADDER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.EMERGENCY_RESCUE_LADDER}.name`),
  },
  [TaxCodes.ROPES_AND_CORDS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ROPES_AND_CORDS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ROPES_AND_CORDS}.name`),
  },
  [TaxCodes.GROUND_ANCHOR_SYSTEMS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GROUND_ANCHOR_SYSTEMS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GROUND_ANCHOR_SYSTEMS}.name`),
  },
  [TaxCodes.DUCT_TAPE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DUCT_TAPE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DUCT_TAPE}.name`),
  },
  [TaxCodes.TOILETS_WATERSENSE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TOILETS_WATERSENSE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TOILETS_WATERSENSE}.name`),
  },
  [TaxCodes.URINALS_WATERSENSE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.URINALS_WATERSENSE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.URINALS_WATERSENSE}.name`),
  },
  [TaxCodes.BATHROOM_FAUCETS_WATERSENSE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BATHROOM_FAUCETS_WATERSENSE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BATHROOM_FAUCETS_WATERSENSE}.name`),
  },
  [TaxCodes.SPRINKLER_BODIES_WATERSENSE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SPRINKLER_BODIES_WATERSENSE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SPRINKLER_BODIES_WATERSENSE}.name`),
  },
  [TaxCodes.IRRIGATION_CONTROLS_WATERSENSE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.IRRIGATION_CONTROLS_WATERSENSE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.IRRIGATION_CONTROLS_WATERSENSE}.name`),
  },
  [TaxCodes.SHOWERHEADS_WATERSENSE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SHOWERHEADS_WATERSENSE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SHOWERHEADS_WATERSENSE}.name`),
  },
  [TaxCodes.AUDIO_TURNTABLES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AUDIO_TURNTABLES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIO_TURNTABLES}.name`),
  },
  [TaxCodes.DIGITAL_MUSIC_PLAYERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DIGITAL_MUSIC_PLAYERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DIGITAL_MUSIC_PLAYERS}.name`),
  },
  [TaxCodes.VIDEO_CAMERAS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.VIDEO_CAMERAS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.VIDEO_CAMERAS}.name`),
  },
  [TaxCodes.DIGITAL_CAMERAS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DIGITAL_CAMERAS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DIGITAL_CAMERAS}.name`),
  },
  [TaxCodes.DIGITAL_PICTURE_FRAMES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DIGITAL_PICTURE_FRAMES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DIGITAL_PICTURE_FRAMES}.name`),
  },
  [TaxCodes.E_BOOK_READERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.E_BOOK_READERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.E_BOOK_READERS}.name`),
  },
  [TaxCodes.HEADPHONES_EARBUDS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HEADPHONES_EARBUDS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HEADPHONES_EARBUDS}.name`),
  },
  [TaxCodes.ELECTRONICS_ACCESSORIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ELECTRONICS_ACCESSORIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ELECTRONICS_ACCESSORIES}.name`),
  },
  [TaxCodes.TELEVISIONS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TELEVISIONS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TELEVISIONS}.name`),
  },
  [TaxCodes.CONSUMER_ELECTRONICS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CONSUMER_ELECTRONICS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CONSUMER_ELECTRONICS}.name`),
  },
  [TaxCodes.MOBILE_PHONES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MOBILE_PHONES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MOBILE_PHONES}.name`),
  },
  [TaxCodes.MOBILE_PHONE_CHARGERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MOBILE_PHONE_CHARGERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MOBILE_PHONE_CHARGERS}.name`),
  },
  [TaxCodes.GAMING_CONSOLE_FIXED]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GAMING_CONSOLE_FIXED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GAMING_CONSOLE_FIXED}.name`),
  },
  [TaxCodes.GAMING_CONSOLE_PORTABLE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GAMING_CONSOLE_PORTABLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GAMING_CONSOLE_PORTABLE}.name`),
  },
  [TaxCodes.COMPUTER_BATTERIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_BATTERIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_BATTERIES}.name`),
  },
  [TaxCodes.COMPUTER_CABLES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_CABLES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_CABLES}.name`),
  },
  [TaxCodes.COMPUTER_DRIVES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_DRIVES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_DRIVES}.name`),
  },
  [TaxCodes.COMPUTER_KEYBOARDS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_KEYBOARDS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_KEYBOARDS}.name`),
  },
  [TaxCodes.COMPUTER_MICROPHONES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_MICROPHONES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_MICROPHONES}.name`),
  },
  [TaxCodes.COMPUTER_MONITORS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_MONITORS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_MONITORS}.name`),
  },
  [TaxCodes.COMPUTER_MOUSE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_MOUSE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_MOUSE}.name`),
  },
  [TaxCodes.COMPUTER_PRINTER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_PRINTER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_PRINTER}.name`),
  },
  [TaxCodes.COMPUTER_SPEAKERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_SPEAKERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_SPEAKERS}.name`),
  },
  [TaxCodes.DOCKING_STATIONS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DOCKING_STATIONS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DOCKING_STATIONS}.name`),
  },
  [TaxCodes.MODEMS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MODEMS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MODEMS}.name`),
  },
  [TaxCodes.MOTHERBOARDS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MOTHERBOARDS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MOTHERBOARDS}.name`),
  },
  [TaxCodes.PORT_REPLICATORS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PORT_REPLICATORS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PORT_REPLICATORS}.name`),
  },
  [TaxCodes.ROUTERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ROUTERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ROUTERS}.name`),
  },
  [TaxCodes.SCANNERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SCANNERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SCANNERS}.name`),
  },
  [TaxCodes.SOUND_CARDS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SOUND_CARDS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SOUND_CARDS}.name`),
  },
  [TaxCodes.VIDEO_GRAPHICS_CARD]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.VIDEO_GRAPHICS_CARD}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.VIDEO_GRAPHICS_CARD}.name`),
  },
  [TaxCodes.WEB_CAMERA]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WEB_CAMERA}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WEB_CAMERA}.name`),
  },
  [TaxCodes.BOOKS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BOOKS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BOOKS}.name`),
  },
  [TaxCodes.CHILDRENS_BOOKS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CHILDRENS_BOOKS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CHILDRENS_BOOKS}.name`),
  },
  [TaxCodes.RELIGIOUS_BOOKS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.RELIGIOUS_BOOKS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.RELIGIOUS_BOOKS}.name`),
  },
  [TaxCodes.BIBLES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BIBLES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BIBLES}.name`),
  },
  [TaxCodes.AUDIOBOOK_PHYSICAL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.AUDIOBOOK_PHYSICAL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.AUDIOBOOK_PHYSICAL}.name`),
  },
  [TaxCodes.NEWSPAPERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NEWSPAPERS}.name`),
  },
  [TaxCodes.PERIODICALS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PERIODICALS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PERIODICALS}.name`),
  },
  [TaxCodes.MAGAZINE_SUBSCRIPTION]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MAGAZINE_SUBSCRIPTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MAGAZINE_SUBSCRIPTION}.name`),
  },
  [TaxCodes.FLEA_TICK_PRODUCTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FLEA_TICK_PRODUCTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FLEA_TICK_PRODUCTS}.name`),
  },
  [TaxCodes.PET_DRUGS_OTC]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PET_DRUGS_OTC}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PET_DRUGS_OTC}.name`),
  },
  [TaxCodes.PET_MEDICAL_SUPPLIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PET_MEDICAL_SUPPLIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PET_MEDICAL_SUPPLIES}.name`),
  },
  [TaxCodes.PET_FOOD]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PET_FOOD}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PET_FOOD}.name`),
  },
  [TaxCodes.PET_VITAMINS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PET_VITAMINS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PET_VITAMINS}.name`),
  },
  [TaxCodes.PET_DRUGS_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PET_DRUGS_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PET_DRUGS_RX}.name`),
  },
  [TaxCodes.PET_FOOD_RX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PET_FOOD_RX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PET_FOOD_RX}.name`),
  },
  [TaxCodes.PERSONAL_COMPUTERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PERSONAL_COMPUTERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PERSONAL_COMPUTERS}.name`),
  },
  [TaxCodes.COMPUTER_STORAGE_MEDIA]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_STORAGE_MEDIA}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COMPUTER_STORAGE_MEDIA}.name`),
  },
  [TaxCodes.PRINTER_INK]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PRINTER_INK}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PRINTER_INK}.name`),
  },
  [TaxCodes.STUDENT_GLOBES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.STUDENT_GLOBES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.STUDENT_GLOBES}.name`),
  },
  [TaxCodes.STUDENT_MAPS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.STUDENT_MAPS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.STUDENT_MAPS}.name`),
  },
  [TaxCodes.PRINTER_PAPER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PRINTER_PAPER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PRINTER_PAPER}.name`),
  },
  [TaxCodes.SCHOOL_TEXTBOOKS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SCHOOL_TEXTBOOKS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SCHOOL_TEXTBOOKS}.name`),
  },
  [TaxCodes.STUDENT_BACKPACKS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.STUDENT_BACKPACKS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.STUDENT_BACKPACKS}.name`),
  },
  [TaxCodes.CALCULATORS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CALCULATORS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CALCULATORS}.name`),
  },
  [TaxCodes.DAILY_PLANNERS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DAILY_PLANNERS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DAILY_PLANNERS}.name`),
  },
  [TaxCodes.STUDENT_PADLOCKS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.STUDENT_PADLOCKS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.STUDENT_PADLOCKS}.name`),
  },
  [TaxCodes.SCHOOL_ART_SUPPLIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SCHOOL_ART_SUPPLIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SCHOOL_ART_SUPPLIES}.name`),
  },
  [TaxCodes.DICTIONARIES_THESAURUSES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DICTIONARIES_THESAURUSES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DICTIONARIES_THESAURUSES}.name`),
  },
  [TaxCodes.STUDENT_SHEET_MUSIC]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.STUDENT_SHEET_MUSIC}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.STUDENT_SHEET_MUSIC}.name`),
  },
  [TaxCodes.SCHOOL_SUPPLIES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SCHOOL_SUPPLIES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SCHOOL_SUPPLIES}.name`),
  },
  [TaxCodes.STAPLERS_STAPLES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.STAPLERS_STAPLES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.STAPLERS_STAPLES}.name`),
  },
  [TaxCodes.PUSH_PINS_TACKS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PUSH_PINS_TACKS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PUSH_PINS_TACKS}.name`),
  },
  [TaxCodes.GRAPHING_CALCULATORS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GRAPHING_CALCULATORS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GRAPHING_CALCULATORS}.name`),
  },
  [TaxCodes.STUDENT_MUSICAL_INSTRUMENTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.STUDENT_MUSICAL_INSTRUMENTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.STUDENT_MUSICAL_INSTRUMENTS}.name`),
  },
  [TaxCodes.CANNED_SOFTWARE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CANNED_SOFTWARE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CANNED_SOFTWARE}.name`),
  },
  [TaxCodes.CANNED_SOFTWARE_NONREC]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CANNED_SOFTWARE_NONREC}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CANNED_SOFTWARE_NONREC}.name`),
  },
  [TaxCodes.SW_MAINT_PREWRITTEN_UPDATES]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_PREWRITTEN_UPDATES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_PREWRITTEN_UPDATES}.name`),
  },
  [TaxCodes.SW_MAINT_PREWRITTEN_ALL]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_PREWRITTEN_ALL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_PREWRITTEN_ALL}.name`),
  },
  [TaxCodes.SW_MAINT_PREWRITTEN_SVC]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_PREWRITTEN_SVC}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_PREWRITTEN_SVC}.name`),
  },
  [TaxCodes.SW_MAINT_PREWRITTEN_TANGIBLE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_PREWRITTEN_TANGIBLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_PREWRITTEN_TANGIBLE}.name`),
  },
  [TaxCodes.SW_MAINT_PREWRITTEN_TANGIBLE_ALL]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_PREWRITTEN_TANGIBLE_ALL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_PREWRITTEN_TANGIBLE_ALL}.name`),
  },
  [TaxCodes.SW_MAINT_CUSTOM_UPDATES]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_CUSTOM_UPDATES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_CUSTOM_UPDATES}.name`),
  },
  [TaxCodes.SW_MAINT_CUSTOM_ALL]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_CUSTOM_ALL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_CUSTOM_ALL}.name`),
  },
  [TaxCodes.SW_MAINT_CUSTOM_SVC]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_CUSTOM_SVC}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_CUSTOM_SVC}.name`),
  },
  [TaxCodes.SW_MAINT_CUSTOM_TANGIBLE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_CUSTOM_TANGIBLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_CUSTOM_TANGIBLE}.name`),
  },
  [TaxCodes.SW_MAINT_CUSTOM_TANGIBLE_ALL]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_CUSTOM_TANGIBLE_ALL}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_CUSTOM_TANGIBLE_ALL}.name`),
  },
  [TaxCodes.SW_MAINT_MANDATORY_PREWRITTEN]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_MANDATORY_PREWRITTEN}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_MANDATORY_PREWRITTEN}.name`),
  },
  [TaxCodes.SW_MAINT_MANDATORY_TANGIBLE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_MANDATORY_TANGIBLE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_MANDATORY_TANGIBLE}.name`),
  },
  [TaxCodes.SW_MAINT_MANDATORY_CUSTOM]: {
    type: TaxType.DIGITAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_MANDATORY_CUSTOM}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_MANDATORY_CUSTOM}.name`),
  },
  [TaxCodes.SW_MAINT_MANDATORY_CUSTOM_TANGIBLE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(
      `taxcode.${TaxCodes.SW_MAINT_MANDATORY_CUSTOM_TANGIBLE}.description`,
    ),
    name: i18n.global.t(`taxcode.${TaxCodes.SW_MAINT_MANDATORY_CUSTOM_TANGIBLE}.name`),
  },
  [TaxCodes.CEREAL_GRAINS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CEREAL_GRAINS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CEREAL_GRAINS}.name`),
  },
  [TaxCodes.PASTA]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PASTA}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PASTA}.name`),
  },
  [TaxCodes.RICE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.RICE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.RICE}.name`),
  },
  [TaxCodes.EDIBLE_OILS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.EDIBLE_OILS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.EDIBLE_OILS}.name`),
  },
  [TaxCodes.SUGAR_SUBSTITUTES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SUGAR_SUBSTITUTES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SUGAR_SUBSTITUTES}.name`),
  },
  [TaxCodes.FLOUR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FLOUR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FLOUR}.name`),
  },
  [TaxCodes.HERBS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.HERBS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.HERBS}.name`),
  },
  [TaxCodes.SEASONINGS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SEASONINGS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SEASONINGS}.name`),
  },
  [TaxCodes.FOOD_COLORING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_COLORING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_COLORING}.name`),
  },
  [TaxCodes.FOOD_NON_IMMEDIATE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_NON_IMMEDIATE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_NON_IMMEDIATE}.name`),
  },
  [TaxCodes.COCOA_MIX]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COCOA_MIX}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COCOA_MIX}.name`),
  },
  [TaxCodes.BABY_FOOD]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BABY_FOOD}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BABY_FOOD}.name`),
  },
  [TaxCodes.BAKING_COCOA]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BAKING_COCOA}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BAKING_COCOA}.name`),
  },
  [TaxCodes.ICE_CUBES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ICE_CUBES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ICE_CUBES}.name`),
  },
  [TaxCodes.MEAT_PRODUCTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MEAT_PRODUCTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MEAT_PRODUCTS}.name`),
  },
  [TaxCodes.NUTS_SEEDS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NUTS_SEEDS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NUTS_SEEDS}.name`),
  },
  [TaxCodes.NUTS_SEEDS_PROCESSED]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NUTS_SEEDS_PROCESSED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NUTS_SEEDS_PROCESSED}.name`),
  },
  [TaxCodes.VEGETABLES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.VEGETABLES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.VEGETABLES}.name`),
  },
  [TaxCodes.CRACKER_BREAD]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CRACKER_BREAD}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CRACKER_BREAD}.name`),
  },
  [TaxCodes.PLAIN_BREADS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PLAIN_BREADS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PLAIN_BREADS}.name`),
  },
  [TaxCodes.SPECIALITY_BREADS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SPECIALITY_BREADS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SPECIALITY_BREADS}.name`),
  },
  [TaxCodes.FOOD_TPP_50_75]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_50_75}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_50_75}.name`),
  },
  [TaxCodes.FOOD_TPP_50_90]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_50_90}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_50_90}.name`),
  },
  [TaxCodes.FOOD_TPP_90_PLUS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_90_PLUS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_90_PLUS}.name`),
  },
  [TaxCodes.FOOD_TPP_LESS_50]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_LESS_50}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_LESS_50}.name`),
  },
  [TaxCodes.FOOD_TPP_90_PLUS_CANDY]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_90_PLUS_CANDY}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_90_PLUS_CANDY}.name`),
  },
  [TaxCodes.FOOD_TPP_50_75_CANDY]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_50_75_CANDY}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_50_75_CANDY}.name`),
  },
  [TaxCodes.FOOD_TPP_76_89]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_76_89}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_76_89}.name`),
  },
  [TaxCodes.FOOD_TPP_76_89_CANDY]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_76_89_CANDY}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_TPP_76_89_CANDY}.name`),
  },
  [TaxCodes.FOOD_CANDY_10_LESS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_CANDY_10_LESS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_CANDY_10_LESS}.name`),
  },
  [TaxCodes.FOOD_CANDY_11_24]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_CANDY_11_24}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_CANDY_11_24}.name`),
  },
  [TaxCodes.FOOD_CANDY_25_49]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_CANDY_25_49}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_CANDY_25_49}.name`),
  },
  [TaxCodes.FOOD_CANDY_50_PLUS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_CANDY_50_PLUS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_CANDY_50_PLUS}.name`),
  },
  [TaxCodes.FOOD_IMMEDIATE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FOOD_IMMEDIATE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FOOD_IMMEDIATE}.name`),
  },
  [TaxCodes.GRANOLA_BARS_FLOUR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GRANOLA_BARS_FLOUR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GRANOLA_BARS_FLOUR}.name`),
  },
  [TaxCodes.GRANOLA_BARS_NO_FLOUR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.GRANOLA_BARS_NO_FLOUR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.GRANOLA_BARS_NO_FLOUR}.name`),
  },
  [TaxCodes.SNACK_FOODS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SNACK_FOODS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SNACK_FOODS}.name`),
  },
  [TaxCodes.BISCUITS_PLAIN]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BISCUITS_PLAIN}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BISCUITS_PLAIN}.name`),
  },
  [TaxCodes.BISCUITS_CHOCOLATE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BISCUITS_CHOCOLATE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BISCUITS_CHOCOLATE}.name`),
  },
  [TaxCodes.DIETARY_SUPPLEMENTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DIETARY_SUPPLEMENTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DIETARY_SUPPLEMENTS}.name`),
  },
  [TaxCodes.PROTEIN_POWDER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PROTEIN_POWDER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PROTEIN_POWDER}.name`),
  },
  [TaxCodes.INFANT_FORMULA]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.INFANT_FORMULA}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.INFANT_FORMULA}.name`),
  },
  [TaxCodes.NUTRITIONAL_SUPPLEMENTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NUTRITIONAL_SUPPLEMENTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NUTRITIONAL_SUPPLEMENTS}.name`),
  },
  [TaxCodes.CANDY]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CANDY}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CANDY}.name`),
  },
  [TaxCodes.CANDY_FLOUR]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CANDY_FLOUR}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CANDY_FLOUR}.name`),
  },
  [TaxCodes.ICE_CREAM_PINT_PLUS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ICE_CREAM_PINT_PLUS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ICE_CREAM_PINT_PLUS}.name`),
  },
  [TaxCodes.ICE_CREAM_LESS_PINT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ICE_CREAM_LESS_PINT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ICE_CREAM_LESS_PINT}.name`),
  },
  [TaxCodes.CHEWING_GUM]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CHEWING_GUM}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CHEWING_GUM}.name`),
  },
  [TaxCodes.BREATH_MINTS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BREATH_MINTS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BREATH_MINTS}.name`),
  },
  [TaxCodes.DRIED_FRUIT_UNSWEETENED]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DRIED_FRUIT_UNSWEETENED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DRIED_FRUIT_UNSWEETENED}.name`),
  },
  [TaxCodes.BEER_MALT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.BEER_MALT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.BEER_MALT}.name`),
  },
  [TaxCodes.SPIRITS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SPIRITS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SPIRITS}.name`),
  },
  [TaxCodes.WINE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WINE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WINE}.name`),
  },
  [TaxCodes.WATER_BOTTLED]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WATER_BOTTLED}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WATER_BOTTLED}.name`),
  },
  [TaxCodes.WATER_CARB_ART]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WATER_CARB_ART}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WATER_CARB_ART}.name`),
  },
  [TaxCodes.WATER_CARB_NAT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WATER_CARB_NAT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WATER_CARB_NAT}.name`),
  },
  [TaxCodes.SODA_NO_JUICE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_NO_JUICE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_NO_JUICE}.name`),
  },
  [TaxCodes.TEA_SWEET]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TEA_SWEET}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TEA_SWEET}.name`),
  },
  [TaxCodes.WATER_SWEET]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WATER_SWEET}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WATER_SWEET}.name`),
  },
  [TaxCodes.WATER_CARB_SWEET]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.WATER_CARB_SWEET}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.WATER_CARB_SWEET}.name`),
  },
  [TaxCodes.SODA_NONCARB_NO_JUICE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_NO_JUICE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_NO_JUICE}.name`),
  },
  [TaxCodes.SODA_CARB_1_9_VEG]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_1_9_VEG}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_1_9_VEG}.name`),
  },
  [TaxCodes.SODA_CARB_1_9_FRUIT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_1_9_FRUIT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_1_9_FRUIT}.name`),
  },
  [TaxCodes.SODA_CARB_10_24_FRUIT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_10_24_FRUIT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_10_24_FRUIT}.name`),
  },
  [TaxCodes.SODA_CARB_10_24_VEG]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_10_24_VEG}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_10_24_VEG}.name`),
  },
  [TaxCodes.SODA_CARB_100_JUICE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_100_JUICE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_100_JUICE}.name`),
  },
  [TaxCodes.SODA_CARB_25_50_FRUIT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_25_50_FRUIT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_25_50_FRUIT}.name`),
  },
  [TaxCodes.SODA_CARB_25_50_VEG]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_25_50_VEG}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_25_50_VEG}.name`),
  },
  [TaxCodes.SODA_CARB_51_69_FRUIT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_51_69_FRUIT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_51_69_FRUIT}.name`),
  },
  [TaxCodes.SODA_CARB_51_69_VEG]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_51_69_VEG}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_51_69_VEG}.name`),
  },
  [TaxCodes.SODA_CARB_70_99_FRUIT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_70_99_FRUIT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_70_99_FRUIT}.name`),
  },
  [TaxCodes.SODA_CARB_70_99_VEG]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_70_99_VEG}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_CARB_70_99_VEG}.name`),
  },
  [TaxCodes.SODA_NONCARB_1_9_VEG]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_1_9_VEG}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_1_9_VEG}.name`),
  },
  [TaxCodes.SODA_NONCARB_1_9_FRUIT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_1_9_FRUIT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_1_9_FRUIT}.name`),
  },
  [TaxCodes.SODA_NONCARB_10_24_FRUIT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_10_24_FRUIT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_10_24_FRUIT}.name`),
  },
  [TaxCodes.SODA_NONCARB_10_24_VEG]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_10_24_VEG}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_10_24_VEG}.name`),
  },
  [TaxCodes.SODA_NONCARB_100_JUICE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_100_JUICE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_100_JUICE}.name`),
  },
  [TaxCodes.SODA_NONCARB_25_50_FRUIT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_25_50_FRUIT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_25_50_FRUIT}.name`),
  },
  [TaxCodes.SODA_NONCARB_25_50_VEG]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_25_50_VEG}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_25_50_VEG}.name`),
  },
  [TaxCodes.SODA_NONCARB_51_69_FRUIT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_51_69_FRUIT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_51_69_FRUIT}.name`),
  },
  [TaxCodes.SODA_NONCARB_51_69_VEG]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_51_69_VEG}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_51_69_VEG}.name`),
  },
  [TaxCodes.SODA_NONCARB_70_99_FRUIT]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_70_99_FRUIT}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_70_99_FRUIT}.name`),
  },
  [TaxCodes.SODA_NONCARB_70_99_VEG]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_70_99_VEG}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SODA_NONCARB_70_99_VEG}.name`),
  },
  [TaxCodes.COFFEE_MILK]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COFFEE_MILK}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COFFEE_MILK}.name`),
  },
  [TaxCodes.COFFEE_SWEET]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COFFEE_SWEET}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COFFEE_SWEET}.name`),
  },
  [TaxCodes.COFFEE_UNSWEET]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COFFEE_UNSWEET}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COFFEE_UNSWEET}.name`),
  },
  [TaxCodes.TEA_CARB_UNSWEET]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TEA_CARB_UNSWEET}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TEA_CARB_UNSWEET}.name`),
  },
  [TaxCodes.TEA_UNSWEET]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TEA_UNSWEET}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TEA_UNSWEET}.name`),
  },
  [TaxCodes.COFFEE_BEANS]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.COFFEE_BEANS}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.COFFEE_BEANS}.name`),
  },
  [TaxCodes.TEA_CARB_SWEET]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TEA_CARB_SWEET}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TEA_CARB_SWEET}.name`),
  },
  [TaxCodes.TEA_LEAVES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.TEA_LEAVES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.TEA_LEAVES}.name`),
  },
  [TaxCodes.ENERGY_DRINK_CARB]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ENERGY_DRINK_CARB}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ENERGY_DRINK_CARB}.name`),
  },
  [TaxCodes.ENERGY_DRINK_NONCARB]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.ENERGY_DRINK_NONCARB}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.ENERGY_DRINK_NONCARB}.name`),
  },
  [TaxCodes.NON_ALC_BEER_WINE]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.NON_ALC_BEER_WINE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.NON_ALC_BEER_WINE}.name`),
  },
  [TaxCodes.PROTEIN_DRINK_MILK]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PROTEIN_DRINK_MILK}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PROTEIN_DRINK_MILK}.name`),
  },
  [TaxCodes.PROTEIN_DRINK_NO_MILK]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.PROTEIN_DRINK_NO_MILK}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.PROTEIN_DRINK_NO_MILK}.name`),
  },
  [TaxCodes.DRINK_MIX_MILK]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DRINK_MIX_MILK}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DRINK_MIX_MILK}.name`),
  },
  [TaxCodes.DRINK_MIX_WATER]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.DRINK_MIX_WATER}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.DRINK_MIX_WATER}.name`),
  },
  [TaxCodes.MILK_SUBSTITUTES]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MILK_SUBSTITUTES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MILK_SUBSTITUTES}.name`),
  },
  [TaxCodes.MILK_COFFEE_TEA]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.MILK_COFFEE_TEA}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.MILK_COFFEE_TEA}.name`),
  },
  [TaxCodes.FITNESS_DUES]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FITNESS_DUES}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FITNESS_DUES}.name`),
  },
  [TaxCodes.FITNESS_INITIATION]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FITNESS_INITIATION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FITNESS_INITIATION}.name`),
  },
  [TaxCodes.FITNESS_TRAINING]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FITNESS_TRAINING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FITNESS_TRAINING}.name`),
  },
  [TaxCodes.FITNESS_SINGLE_USE]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.FITNESS_SINGLE_USE}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.FITNESS_SINGLE_USE}.name`),
  },
  [TaxCodes.SPORT_INSTRUCTION]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SPORT_INSTRUCTION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SPORT_INSTRUCTION}.name`),
  },
  [TaxCodes.CASH_DONATION]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.CASH_DONATION}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.CASH_DONATION}.name`),
  },
  [TaxCodes.OPTIONAL_GRATUITY]: {
    type: TaxType.SERVICES,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.OPTIONAL_GRATUITY}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.OPTIONAL_GRATUITY}.name`),
  },
  [TaxCodes.SHIPPING]: {
    type: TaxType.PHYSICAL,
    performanceLocationRequirement: "none",
    description: i18n.global.t(`taxcode.${TaxCodes.SHIPPING}.description`),
    name: i18n.global.t(`taxcode.${TaxCodes.SHIPPING}.name`),
  },
};
